export default [
    {
        path: 'midias',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'AdminMidiaController' }
    }, 
     {
        path: 'midia/add',
        component: require('./Add').default,
        meta: { middleware: 'auth', controller: 'AdminMidiaController' },
    },
    {
        path: 'midia/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'AdminMidiaController' },
    },
    {
        path: 'midia/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminMidiaController'
        }
    },

];


